import React from 'react';
import Container from './Container';

const Section = ({ 
  children, 
  className = '',
  containerProps = {},
  background = 'transparent',
  padding = 'default',
  ...props 
}) => {
  const backgrounds = {
    transparent: '',
    white: 'bg-white',
    gray: 'bg-gray-100',
    'gray-light': 'bg-gray-50',
    'gray-dark': 'bg-gray-300',
    primary: '',
    dark: 'bg-gray-900'
  };

  const paddings = {
    none: '',
    small: 'py-8',
    default: 'py-16',
    large: 'py-8'
  };

  const sectionClasses = `${backgrounds[background]} ${paddings[padding]} ${className}`;
  const sectionStyle = background === 'primary' ? { backgroundColor: '#db0058' } : {};

  return (
    <section className={sectionClasses} style={sectionStyle} {...props}>
      <Container {...containerProps}>
        {children}
      </Container>
    </section>
  );
};

export default Section;